import { Box, Stack, Text, ThemeContext } from '@vouched.id/vault';
import React, { useContext } from 'react';
import { AmlFieldLabel } from 'components/account/jobs-v2/dropdowns/AML/AmlFieldLabel';
import { AML_BORDER_COLOR } from 'components/account/jobs-v2/dropdowns/AML/amlV2Utils';
import { StatusColors } from 'components/account/jobs-v2/utils';
const NOT_PROVIDED = 'Not provided';
const getListingFields = (listing) => [
    { label: 'List Name', value: listing.listName?.toUpperCase() ?? null },
    ...(listing.url ? [{ label: 'Url', value: listing.url }] : []),
    {
        label: 'Countries',
        value: listing.countryCodes.length > 0 ? listing.countryCodes.join(', ') : null
    },
    ...(listing.politicalPositions.length > 0
        ? [
            {
                label: 'Political Positions',
                value: listing.politicalPositions.join(', ')
            }
        ]
        : []),
    ...(listing.listingStartedAt
        ? [
            {
                label: 'Listing Started',
                value: new Date(listing.listingStartedAt).toLocaleString()
            }
        ]
        : []),
    ...(listing.listingEndedAt
        ? [
            {
                label: 'Listing Ended',
                value: new Date(listing.listingEndedAt).toLocaleString()
            }
        ]
        : [])
];
export const AmlV2Listing = ({ listing }) => {
    const { tokens } = useContext(ThemeContext).theme;
    return (React.createElement(Stack, { paddingX: "spacing.large", paddingY: "spacing.default", spacing: "spacing.small", style: {
            border: `1px solid ${AML_BORDER_COLOR}`,
            borderRadius: tokens.radii.xlarge
        } },
        listing.amlTypes.length > 0 && (React.createElement(Box, { display: "flex", flexWrap: "wrap", style: { gap: tokens.spacing.xsmall } }, listing.amlTypes.map((amlType) => (React.createElement(Text, { key: amlType, style: {
                padding: `${tokens.spacing.xsmall2} ${tokens.spacing.small}`,
                borderRadius: tokens.radii.large,
                backgroundColor: StatusColors.Warning,
                color: tokens.colors.textPrimary,
                fontSize: tokens.text.size.xsmall,
                fontWeight: tokens.text.weight.extraBold,
                letterSpacing: '0.03em'
            }, tag: "span" }, amlType.toUpperCase()))))),
        React.createElement(Stack, { paddingTop: "spacing.small", spacing: "spacing.small", style: { borderTop: `1px solid ${AML_BORDER_COLOR}` } }, getListingFields(listing).map(({ label, value }) => (React.createElement(Box, { display: "flex", flexDirection: "column", key: label, style: { gap: tokens.spacing.xsmall2 } },
            React.createElement(AmlFieldLabel, null, label),
            React.createElement(Text, { "data-ph-mask": true, style: value
                    ? {
                        fontWeight: tokens.text.weight.semiBold,
                        overflowWrap: 'anywhere'
                    }
                    : { fontStyle: 'italic', color: tokens.colors.gray600 } }, value ?? NOT_PROVIDED)))))));
};
